import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';

import { config } from '_config';
import { theme } from '_constants/theme';
import Text from '_components/atomic/layouts/Card/Text';

const ChevronRightSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={16}
    width={16}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g>
      <path
        d="M10 6L16 12L10 18"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large32X * 10}px;
  width: 100%;
  padding-top: ${theme.spaces.large6X}px;
`;

const StyledInnerContainer = styled.div`
  padding-top: ${theme.spaces.large23X}px;
  padding-bottom: ${theme.spaces.large19X * 2}px;
  padding-left: ${theme.spaces.large21X}px;
  padding-right: ${theme.spaces.large21X}px;
  border: 1px solid #413c3c;
  border-radius: 32px;
  background: linear-gradient(
    135deg,
    #1c1b18,
    #3a3a38 33.33%,
    #1c1b18 66.67%,
    #3a3a38
  );

  > :nth-child(2) {
    margin-bottom: ${theme.spaces.large12X}px;
  }

  position: relative;

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.large12X}px;
    padding-bottom: ${theme.spaces.large32X * 2}px;
    padding-left: ${theme.spaces.large}px;
    padding-right: ${theme.spaces.large}px;
    border-radius: unset;

    > :nth-child(2) {
      margin-bottom: ${theme.spaces.large6X}px;
    }
  }
`;

const StyledTitlePart1 = styled.span`
  font-family: 'Radwave';
  font-size: ${theme.fontSizes.large13X}px;
  font-style: normal;
  font-weight: 700;
  line-height: ${theme.fontSizes.large13X}px;
  color: ${theme.colors.white};

  @media ${theme.devices.tablet} {
    display: block;
    margin-bottom: ${theme.spaces.small2X}px;
    font-size: ${theme.fontSizes.large6X}px;
    line-height: ${theme.fontSizes.large6X}px;
  }
`;

const StyledTitlePart2 = styled.span`
  display: inline-block;
  margin-right: ${theme.spaces.small - 2}px;
  margin-bottom: ${theme.spaces.small2X}px;
  font-family: 'Radwave';
  font-size: ${theme.fontSizes.large13X}px;
  font-style: normal;
  font-weight: 700;
  line-height: ${theme.fontSizes.large13X}px;
  text-shadow: -1px 0 ${theme.colors.white}, 0 1px ${theme.colors.white},
    1px 0 ${theme.colors.white}, 0 -1px ${theme.colors.white};
  color: #413c3c;

  @media ${theme.devices.tablet} {
    display: block;
    font-size: ${theme.fontSizes.large6X}px;
    line-height: ${theme.fontSizes.large6X}px;
  }
`;

const StyledTitlePart3 = styled.span`
  font-family: 'Radwave';
  font-size: ${theme.fontSizes.large13X}px;
  font-style: normal;
  font-weight: 700;
  line-height: ${theme.fontSizes.large13X}px;
  color: #f7a300;

  @media ${theme.devices.tablet} {
    display: block;
    font-size: ${theme.fontSizes.large6X}px;
    line-height: ${theme.fontSizes.large6X}px;
  }
`;

const StyledItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${theme.spaces.large8X}px;

  @media ${theme.devices.tablet} {
    margin-bottom: ${theme.spaces.large6X}px;
  }
`;

const StyledItemImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${theme.spaces.large}px;

  img {
    height: 32px;
    width: 32px;
  }
`;

const StyledRunningLineContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spaces.small}px;
  position: absolute;
  min-height: 40px;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-top: ${theme.spaces.small - 2}px;
  padding-bottom: ${theme.spaces.small - 2}px;
  border-bottom-left-radius: 32px;
  border-bottom-right-radius: 32px;
  background-color: ${theme.colors.black};
  overflow: hidden;

  @keyframes RunningLine {
    0% {
      transform: translateX(-107%);
    }

    to {
      transform: translateX(0);
    }
  }

  @media ${theme.devices.tablet} {
    border-radius: unset;
  }
`;

const StyledRunningLineItem = styled.div`
  display: flex;
  gap: ${theme.spaces.small}px;
  letter-spacing: 0.3rem;
  animation: RunningLine 10s linear infinite;
`;

const StyledImageContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: -30px;

  img {
    height: 424px;
  }

  @media ${theme.devices.laptopS} {
    right: 0;
    bottom: 40px;

    img {
      height: 276px;
    }
  }
`;

const BenefitsSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <div>
          <StyledTitlePart1>WE TAKE CARE</StyledTitlePart1>
        </div>
        <div>
          <StyledTitlePart2>OF EVERYTHING</StyledTitlePart2>
          <StyledTitlePart3>FOR YOU!</StyledTitlePart3>
        </div>
        <Text
          size={theme.fontSizes.largeX}
          weight={400}
          color={theme.colors.white}
          leftSpace={theme.spaces.large2X}
          bottomSpace={theme.spaces.large16X}
          desktop
        >
          There&apos;s a reason over 1,000,000 businesses have started with
          Incorpified. <br />
          We include many amazing benefits with all packages.
        </Text>
        <Text
          size={theme.fontSizes.regular}
          weight={300}
          lineHeightRatio={1.5}
          color={theme.colors.white}
          leftSpace={theme.spaces.large2X}
          bottomSpace={theme.spaces.large8X}
          mobile
        >
          There&apos;s a reason over 1,000,000 businesses have started with
          Incorpified. <br />
          We include many amazing benefits with all packages.
        </Text>
        <Row>
          <Col xs={12} md={4}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Company name verification
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Company name verification
              </Text>
            </StyledItemContainer>
          </Col>
          <Col xs={12} md={8}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Next business day processing
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Next business day processing
              </Text>
            </StyledItemContainer>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Free first year registered agent
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Free first year registered agent
              </Text>
            </StyledItemContainer>
          </Col>
          <Col xs={12} md={8}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Lifetime company alerts
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Lifetime company alerts
              </Text>
            </StyledItemContainer>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Preparation and filing of articles
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Preparation and filing of articles
              </Text>
            </StyledItemContainer>
          </Col>
          <Col xs={12} md={8}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Online order status tracking
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Online order status tracking
              </Text>
            </StyledItemContainer>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Free business tax consult
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Free business tax consult
              </Text>
            </StyledItemContainer>
          </Col>
          <Col xs={12} md={8}>
            <StyledItemContainer>
              <StyledItemImg>
                <picture>
                  <source
                    srcSet={`${config.basePath}/images/v4-check-circle.svg`}
                    type="image/svg+xml"
                  />
                  <img
                    src={`${config.basePath}/images/v4-check-circle.svg`}
                    alt=""
                  />
                </picture>
              </StyledItemImg>
              <Text
                size={theme.fontSizes.largeX}
                weight={400}
                color={theme.colors.white}
                desktop
              >
                Lifetime customer support
              </Text>
              <Text
                size={theme.fontSizes.regular}
                weight={300}
                color={theme.colors.white}
                mobile
              >
                Lifetime customer support
              </Text>
            </StyledItemContainer>
          </Col>
        </Row>
        <StyledRunningLineContainer>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
          <StyledRunningLineItem>
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              LLC
            </Text>
            <ChevronRightSvg />
            <Text
              size={theme.fontSizes.small}
              weight={700}
              color={theme.colors.white}
            >
              FORM
            </Text>
            <ChevronRightSvg />
          </StyledRunningLineItem>
        </StyledRunningLineContainer>
        <StyledImageContainer>
          <picture>
            <source
              srcSet={`${config.basePath}/images/v4-bottom-bizfiz-llc.png`}
              type="image/png"
            />
            <img
              src={`${config.basePath}/images/v4-bottom-bizfiz-llc.png`}
              alt="Biz Fiz LLC"
            />
          </picture>
        </StyledImageContainer>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default BenefitsSection;
